import { RootState } from "@/app/stores"
import { getBonusTransaction, IGetBonusTransaction } from "@/shared/api/bonuses"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchBonusTransaction = createAsyncThunk<
    IGetBonusTransaction,
    string,
    { state: RootState }
>('bonusTransaction/fetchBonusTransaction', async (id, thunkAPI) => {
    try {
        const data = await getBonusTransaction(id)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})